import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { REFRESH_INTERVAL_MS } from '../lib/constants';
import { useCatalogStore } from '../store/catalogStore';
import { useCollectionStore } from '../store/collectionStore';

const collectionPath = /^\/collections\/([^/]+)$/;

/** Re-fetch whatever listing is on screen so prices and stock stay current. */
export function refreshStorefront(pathname: string) {
  const collections = useCollectionStore.getState();
  const { query, fetchSearch } = useCatalogStore.getState();
  collections.invalidateHome();
  if (pathname === '/') void collections.fetchHome();
  if (query) void fetchSearch(query);
  const match = pathname.match(collectionPath);
  if (match) void collections.reloadPage(decodeURIComponent(match[1]));
}

/** Refresh the storefront on a fixed interval, and on window focus once the data is that stale. */
export function useStorefrontRefresh() {
  const { pathname } = useLocation();
  const latestPath = useRef(pathname);
  useEffect(() => {
    latestPath.current = pathname;
  }, [pathname]);
  useEffect(() => {
    let last = Date.now();
    const refresh = () => {
      last = Date.now();
      refreshStorefront(latestPath.current);
    };
    const refreshIfStale = () => {
      if (Date.now() - last >= REFRESH_INTERVAL_MS) refresh();
    };
    window.addEventListener('focus', refreshIfStale);
    const timer = setInterval(refresh, REFRESH_INTERVAL_MS);
    return () => {
      window.removeEventListener('focus', refreshIfStale);
      clearInterval(timer);
    };
  }, []);
}
